ACC.track = {
	trackAddToCart: function (productCode, quantity, cartData)
	{
		window.mediator.publish('trackAddToCart',{
			productCode: productCode,
			quantity: quantity,
			cartData: cartData
		});
	},
	trackRemoveFromCart: function(productCode, initialCartQuantity)
	{
		window.mediator.publish('trackRemoveFromCart',{
			productCode: productCode,
			initialCartQuantity: initialCartQuantity
		});
	},
	trackUpdateCart: function(productCode, initialCartQuantity, newCartQuantity)
	{
		window.mediator.publish('trackUpdateCart',{
			productCode: productCode,
			initialCartQuantity: initialCartQuantity,
			newCartQuantity: newCartQuantity
		});
	},
    setUrlHash: function(paramName,url) {
	    var hash = "#" + paramName;
	    if(url.indexOf(hash) === -1) {
            url = url + hash;
        }
        return url;
    },
    getUrlHash: function(paramName){
        var values = window.location.hash.split('#');
        if(jQuery.inArray(paramName,values) != -1){
            return true;
        }else{
            return false;
        }
    },
    removeUrlHash: function(paramName){
        var values = window.location.hash.split('#');
        var newValues = [];
        for(var i = 0 ; i < values.length ; i++) {
            if(values[i] != paramName && values[i] != "") {
                newValues.push(values[i])
            }
        }
        window.location.hash = newValues.join('#');
    },
    substringBefore: function (text, comparison) {
        var indexOf = text.indexOf(comparison);
        return indexOf === -1 ? text : text.substr(0, indexOf);
    },
    setUrl: function(url){
        var oldUrl = window.location.href;
        var newUrl = ACC.track.cleanUrl(url);
        window.location.href = newUrl;

        // Now test, if the url before the anchor did not change. Then we need to reload the window explicitly
        var oldUrlBeforeHash = ACC.track.substringBefore(oldUrl, '#');
        var newUrlBeforeHash = ACC.track.substringBefore(newUrl, '#');

        if (oldUrlBeforeHash === newUrlBeforeHash) {
            window.location.reload();
        }
    },
    cleanUrl: function(url){
    	var loc = window.location;
        var context = "" + loc.protocol + "//" + loc.host;
        
        // clean multiple URL context
        var cleanUrl = context + url.replace(new RegExp(context, 'g'),"");
        
        return cleanUrl; 
    },
    setGaCookie: function(hash1, hash2){
        var gaCookie = {par1: "", par2: ""};
        gaCookie.par1 = hash1;
        gaCookie.par2 = hash2;
        $.session.set('gaValues', JSON.stringify(gaCookie));
    }
};

